import Vue from "vue";
import moment from "moment";
import CKEditor from "ckeditor4-vue";
import DatePicker from "vue2-datepicker";
import StaffLetterServices from "@/service/StaffLetterServices";
import UserService from "@/service/UserService";
import DocumentTemplateService from "@/service/DocumentTemplateService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Staff } from "@/model/Staff";
import { StaffLetter } from "@/model/StaffLetter";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employeeLettersValidationObj from "./S070200-EmployeeLettersValidation.js";
import Settings from "../../../constants/Settings.js";
var employeeLettersDataValidationObj = new employeeLettersValidationObj();
Vue.use(CKEditor);
export default {
  name: "employeeLetters",
  mounted() {
    employeeLettersDataValidationObj.employeeLettersValidation();
    this.getDocTypes();
    this.getAllUsers();
    this.initCKEditor();
  },
  components: {
    DatePicker
  },
  data: () => ({
    dictEnum: dictEnum,
    staff: new Staff(),
    staffLetter: new StaffLetter(),
    tempStaffLetter: new StaffLetter(),
    docTypeList: [],
    docTempList: [],
    isEditMode: false,
    isLoaded: true,
    selectedCompany: "",
    docContent: "",
    staffLetterList: [],
    userList: [],
    editorConfig: {
      extraPlugins: "print,pagebreak,exportpdf",
      toolbar: [
        {
          name: "document",
          items: ["Source", "-", "Save", "NewPage", "-", "Templates"]
        },
        {
          name: "clipboard",
          items: [
            "Cut",
            "Copy",
            "Paste",
            "PasteText",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo"
          ]
        },
        {
          name: "editing",
          items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"]
        },
        {
          name: "forms",
          items: [
            "Form",
            "Checkbox",
            "Radio",
            "TextField",
            "Textarea",
            "Select",
            "Button",
            "ImageButton",
            "HiddenField"
          ]
        },
        "/",
        {
          name: "basicstyles",
          items: [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
            "CopyFormatting",
            "RemoveFormat"
          ]
        },
        {
          name: "paragraph",
          items: [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language"
          ]
        },
        { name: "links", items: ["Link", "Unlink", "Anchor"] },
        {
          name: "insert",
          items: [
            "Image",
            "Flash",
            "Table",
            "HorizontalRule",
            "Smiley",
            "SpecialChar",
            "PageBreak",
            "Iframe"
          ]
        },
        "/",
        { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
        { name: "colors", items: ["TextColor", "BGColor"] },
        { name: "tools", items: ["Maximize", "ShowBlocks"] }
      ]
    }
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    }
  },
  methods: {
    initCKEditor() {
      // 合并当前编辑器配置，并移除通知插件
      CKEDITOR.replace('editor', {
        ...this.editorConfig,
        removePlugins: 'notification'
    });
    CKEDITOR.on('instanceReady', (event) => {
        const notificationsArea = document.querySelector('.cke_notifications_area');
        console.log('Notifications Area:', notificationsArea);
        if (notificationsArea) {
            notificationsArea.style.display = 'none';
        }
    });
    },
    init() {
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".employee-data .content-header").height();
      var letterHeaderHeight = $(".letter-header-section").height();
      var contentHeaderHeight = $(".content-header-section").height();
      var docHeight = documentHeight != undefined ? documentHeight : 657;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var letterHeight =
        letterHeaderHeight != undefined && letterHeaderHeight != 0
          ? letterHeaderHeight
          : 182;
      var contentHeight =
        contentHeaderHeight != undefined && contentHeaderHeight != 0
          ? contentHeaderHeight
          : 455;
      var remarkHeight =
        docHeight -
        headHeight -
        tabHeaderHeight -
        letterHeight -
        contentHeight -
        90;
      $("#LetterRemark").attr(
        "style",
        "height: " + remarkHeight + "px !important"
      );
    },
    async getAllDocTempListByType() {
      var self = this;
      const obj = {
        type: self.staffLetter.DocTypeCode
      };
      const response = await DocumentTemplateService.getAllDocTempListByType(
        obj
      );
      if (response.data.IsSuccess) {
        this.docTempList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDocTypes() {
      const obj = {};
      const response = await DocumentTemplateService.getDocTypes(obj);
      if (response.data.IsSuccess) {
        this.docTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllUsers() {
      var self = this;
      const obj = {
        searchText: ""
      };
      const response = await UserService.getAllUsers(obj);
      if (response.data.IsSuccess) {
        self.userList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getStaffLetterList() {
      var self = this;
      const obj = {
        staffId: self.staff.StaffID
      };
      const response = await StaffLetterServices.getStaffLetterList(obj);
      if (response.data.IsSuccess) {
        self.staffLetterList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getStaffLetterDetail(staffLetterDetail) {
      var self = this;
      self.tempStaffLetter = staffLetterDetail;
      const obj = {
        staffId: self.tempStaffLetter.StaffID,
        dateIssue: moment(self.tempStaffLetter.DateIssue).format(
          Settings.DateTime.yyyymmdd
        ),
        seq: Number(self.tempStaffLetter.Seq),
        docTypeCode: self.tempStaffLetter.DocTypeCode,
        tempCode: self.tempStaffLetter.TempCode
      };
      const response = await StaffLetterServices.getStaffLetterDetail(obj);
      if (response.data.IsSuccess) {
        self.staffLetter = response.data.Data;
        if (
          self.staffLetter.DateIssue != null &&
          self.staffLetter.DateIssue != ""
        ) {
          self.staffLetter.DateIssue = moment(
            String(self.staffLetter.DateIssue)
          ).format(Settings.DateTime.yyyymmdd);
        }
        self.staffLetter.IsNew = false;
        self.isEditMode = false;
        self.getAllDocTempListByType();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getStaffLetterDetailByStaffId() {
      var self = this;
      self.docContent = "";
      if (
        self.staffLetter.StaffID != "" &&
        self.staffLetter.DateIssue != "" &&
        self.staffLetter.DateIssue != null &&
        self.staffLetter.Seq != "" &&
        self.staffLetter.DocTypeCode != "" &&
        self.staffLetter.TempCode != ""
      ) {
        self.docContent =
          "<img src='" +
          self.staff.LetterHead +
          "'style='width:100%'/>" +
          self.staffLetter.DocContent;
        $("#viewStaffLetter").modal("show");
      } else {
        SweetAlertService.warning(
          "Warn",
          self.t.t(dictEnum.WARN_SelectOneRecord)
        );
      }
    },
    async printStaffLetter() {
      var self = this;
      if (
        self.staffLetter.StaffID != "" &&
        self.staffLetter.DateIssue != "" &&
        self.staffLetter.DateIssue != null &&
        self.staffLetter.Seq != "" &&
        self.staffLetter.DocTypeCode != "" &&
        self.staffLetter.TempCode != ""
      ) {
        var myWindow = window.open("", "");
        myWindow.document.write(
          "<img src='" +
            self.staff.LetterHead +
            "'/>" +
            self.staffLetter.DocContent
        );
        myWindow.document.close();
        myWindow.focus();
        myWindow.print();
        myWindow.onafterprint = window.close;
      } else {
        SweetAlertService.warning(
          "Warn",
          self.t.t(dictEnum.WARN_SelectOneRecord)
        );
      }
    },
    async saveStaffLetter() {
      var self = this;
      if (!self.isEditMode && !self.staffLetter.IsNew) {
        return;
      }
      self.$validator.validateAll().then(result => {
        console.log("result", result, self.$validator.validateAll());
        if (result) {
          self.staffLetter.StaffID = self.staff.StaffID;
          self.staffLetter.Seq = Number(self.staffLetter.Seq);
          self.staffLetter.DateIssue = moment(
            self.staffLetter.DateIssue
          ).format(Settings.DateTime.yyyymmdd);
          self.staffLetter.AddBy = self.$store.getters[StoreGetter.user].UserID;
          self.staffLetter.ModifyBy =
            self.$store.getters[StoreGetter.user].UserID;
          var obj = {
            model: self.staffLetter
          };
          if (!self.isEditMode) {
            self.addStaffLetter(obj);
          } else {
            self.editStaffLetterData(obj);
          }
        }
      });
    },
    async addStaffLetter(obj) {
      var self = this;
      const response = await StaffLetterServices.addStaffLetter(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetStaffLetterData();
        await self.getStaffLetterList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async editStaffLetterData(obj) {
      var self = this;
      const response = await StaffLetterServices.updateStaffLetter(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetStaffLetterData();
        await self.getStaffLetterList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onAddButtonClick: function() {
      this.resetStaffLetterData();
      this.staffLetter.IsNew = true;
      this.isLoaded = false;
      this.isLoaded = true;
    },
    onEditButtonClick: function() {
      var self = this;
      if (
        self.staffLetter.StaffID != "" &&
        self.staffLetter.DateIssue != "" &&
        self.staffLetter.DateIssue != null &&
        self.staffLetter.Seq != "" &&
        self.staffLetter.DocTypeCode != "" &&
        self.staffLetter.TempCode != ""
      ) {
        self.isEditMode = true;
        self.staffLetter.IsNew = false;
        self.isLoaded = false;
        self.isLoaded = true;
      } else {
        SweetAlertService.warning(
          "Warn",
          self.t.t(dictEnum.MSG_SelectEditRecord)
        );
      }
    },
    resetStaffLetterData: function() {
      var self = this;
      self.docTempList = [];
      self.docContent = "";
      self.isEditMode = false;
      self.tempStaffLetter = new StaffLetter();
      self.staffLetter = new StaffLetter();
      self.$validator.reset();
      self.vErrors.clear();
    },
    changeLetter: function() {
      var self = this;
      self.staffLetter.DocContent = "";
      if (self.staffLetter.DocTypeCode != "") {
        self.getAllDocTempListByType();
      }
    },
    async changeTemplate() {
      var self = this;
      //var docTempDetail = self.docTempList.find((obj) => obj.TempCode == self.staffLetter.TempCode);
      //if (docTempDetail != null && docTempDetail != undefined) {
      //  self.staffLetter.DocContent = docTempDetail.DocContent;
      //}
      const obj = {
        staffId: self.staff.StaffID,
        type: self.staffLetter.DocTypeCode,
        tempCode: self.staffLetter.TempCode
      };
      const response = await StaffLetterServices.getDocTempDetail(obj);
      if (response.data.IsSuccess) {
        var docTempDetail = response.data.Data;
        if (docTempDetail != null && docTempDetail != undefined) {
          self.staffLetter.DocContent = docTempDetail.DocContent;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    closePopup: function() {
      var self = this;
      self.docContent = "";
      $("#viewStaffLetter").modal("hide");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeLetters/S070200-EmployeeLetters.js